/** 分屏相关接口 */
import request from '@/utils/util.request';

/*
 *  (windows) 分屏页面加载配置
 */
export const windows_loaddata = (data) => {
	return request({
		url: '/windows/loaddata',
		data,
	});
};

/*
 *  (windows) 分屏页面加载模板
 */
export const windows_load_templates = (data) => {
	return request({
		url: '/windows/loadtemplates',
		data,
	});
};

/*
 *  (windows) 分屏页面选择模板
 *  @param {int} id:
 */
export const windows_select_template = (data) => {
	return request({
		url: '/windows/selecttemplate',
		data,
	});
};

/*
 *  (windows) 分屏页面 分屏开关
 *  @param {int} value: 0 | 1
 */
export const windows_switch = (data) => {
	return request({
		url: '/windows/switchmode',
		data,
	});
};
